import { useState } from 'react';
import { Tooltip, usePopper, Popover } from 'dodoc-design-system';
import { openAndUpdateModal } from '_common/modals/ModalsSlice';
import { useSelector, useDispatch } from '_common/hooks';
import EditorManager from 'Editor/services/EditorManager';
import ToolbarToggleButton from 'Editor/components/ToolbarToggleButton/ToolbarToggleButton';
import ColorsMenu from 'Editor/components/ColorsMenu/ColorsMenu';
import StylesUtils from 'Editor/services/Styles/Utils/StylesUtils';

const FontColor = ({ isReadOnlyMode }: { isReadOnlyMode: boolean }) => {
  const dispatch = useDispatch();
  const fontColor = useSelector((state) =>
    state.editor.toolbar.color ? state.editor.toolbar.color.replace(/ /g, '') : '',
  );
  const [documentColors, setDocumentColors] = useState<
    { r: string | number; g: string | number; b: string | number; rgb: string }[]
  >([]);
  const { isOpen, popperProps, referenceProps, close } = usePopper({
    placement: 'bottom-start',
  });

  const onOpenColorsPopover = () => {
    const manager = EditorManager.getInstance();
    const documentColors = manager.getDocumentColors();
    if (documentColors) {
      setDocumentColors(documentColors);
    }
  };

  const onFontFamilyChange = (color: string) => {
    EditorManager.getInstance().toggleSelectionStyle(StylesUtils.STYLES.COLOR, color);
  };

  const onClearParagraphBackgroundColor = () => {
    EditorManager.getInstance().removeSelectionStyle(StylesUtils.STYLES.COLOR);
  };

  const openColorPickerModal = () => {
    dispatch(
      openAndUpdateModal({
        modal: 'ColorPickerModal',
        data: {
          action: 'toggleSelectionStyle',
          actionValues: { style: StylesUtils.STYLES.COLOR },
        },
      }),
    );
  };

  return (
    <>
      <Tooltip content="Color" testId="font-color-tooltip">
        <div>
          <ToolbarToggleButton
            disabled={isReadOnlyMode}
            isActive={isOpen}
            toggleButtonClicked={() => {
              onOpenColorsPopover();
              referenceProps.onClickCapture();
            }}
            icon="EditorColor"
            color={fontColor}
            testId="font-color"
            {...referenceProps}
          />
        </div>
      </Tooltip>
      <Popover {...popperProps} testId="font-color-popper">
        <ColorsMenu
          documentColors={documentColors}
          toggle={close}
          changeBackgroundColor={(color: string) => {
            onFontFamilyChange(color);
            close();
          }}
          clearBackgroundColor={() => {
            onClearParagraphBackgroundColor();
            close();
          }}
          selected={fontColor}
          setOpenColorPickerModal={openColorPickerModal}
          attribute={undefined}
        />
      </Popover>
    </>
  );
};

export default FontColor;
